import React from "react";
import { Link } from "react-router-dom";


import { MDBBtn, MDBBtnGroup, MDBIcon} from "mdbreact";
import {  MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';


class Actions extends React.Component  {
  

  constructor(props){
    super();
    this.state = {deleteModal:false};
   
  }


  componentDidMount(){


  }



toggle = () => {

  this.setState({
    deleteModal: !this.state.deleteModal
  });
}

  deleteFromDb = (key) => {
    this.props.firebaseDb.child(key).remove();
    this.setState({deleteModal:false});
  };

  


  render() {
    const {id,baseName} = this.props;
    return (
    <div className="btn-toolbar" role="toolbar">
    <MDBBtnGroup className="mr-2">
     <Link to={"/"+baseName+"-edit-view/"+id}><MDBBtn color="success lighten-2">
        <MDBIcon icon="eye" />
      </MDBBtn>
      </Link> 
      <MDBBtn onClick={this.toggle} color="danger lighten-2">
        <MDBIcon  icon="trash-alt" />
      </MDBBtn>
      <Link to={"/"+baseName+"-edit-view/"+id}><MDBBtn color="primary lighten-2">
        <MDBIcon icon="edit" />
      </MDBBtn>
      </Link>
    </MDBBtnGroup>

    <MDBModal isOpen={this.state.deleteModal} toggle={this.toggle} size="sm">
        <MDBModalHeader toggle={this.toggle}>Delete Record</MDBModalHeader>
        <MDBModalBody>
        Are you sure you want to delete?
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn color="secondary" size="sm" onClick={this.toggle}>Cancel</MDBBtn>
          <MDBBtn color="primary" onClick={()=>this.deleteFromDb(id)} size="sm">Delete</MDBBtn>
        </MDBModalFooter>
      </MDBModal>


  </div>
    
  )
};
}


export default Actions;
